import { clienteService } from "@/_services";

export const cliente = {
  namespaced: true,
  state: {
    entity: {
      data: [],
      status: {},
    },
    new: {
      data: [],
      status: {},
    },
    update: {
      data: [],
      status: {},
    },
    cliente: {
      data: [],
      status: {},
    },
    estadoCliente: {
      data: [],
      status: {},
    },
    rmaFile: {
      data: {},
      status: {},
    },
    rmaFileDelete: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getClienteFichaRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getClienteFichaError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
    getClienteFichaSuccess(state, ficha) {
      state.entity.data = ficha;
      state.entity.status = {
        loaded: true,
      };
    },
    newClienteRequest(state) {
      state.new.status = {
        creating: true,
      };
    },
    newClienteError(state, error) {
      state.new.data = null;
      state.new.status = {
        error,
      };
    },
    newClienteSuccess(state, cliente) {
      state.new.data = cliente;
      state.new.status = {
        created: true,
      };
    },
    editClienteRequest(state) {
      state.update.status = {
        editing: true,
      };
    },
    editClienteError(state, error) {
      state.update.data = null;
      state.update.status = {
        error,
      };
    },
    editClienteSuccess(state, clienteEditado) {
      state.update.data = clienteEditado;
      state.update.status = {
        edited: true,
      };
    },

    editClienteEstadoRequest(state) {
      state.estadoCliente.status = {
        editing: true,
      };
    },
    editClienteEstadoError(state, error) {
      state.estadoCliente.data = null;
      state.estadoCliente.status = {
        error,
      };
    },
    editClienteEstadoSuccess(state, clienteEditado) {
      state.estadoCliente.data = clienteEditado;
      state.estadoCliente.status = {
        edited: true,
      };
    },

    desactivarClienteRequest(state) {
      state.cliente.status = {
        loading: true,
      };
    },
    desactivarClienteSuccess(state, clienteResponse) {
      state.cliente.data = clienteResponse;
      state.cliente.status = {
        loaded: true,
      };
    },
    desactivarClienteError(state, error) {
      state.cliente.data = [];
      state.cliente.status = {
        error,
      };
    },
    getRMAFileRequest(state) {
      state.rmaFile.status = {
        downloading: true,
      };
    },
    getRMAFileError(state, error) {
      state.rmaFile.data = null;
      state.rmaFile.status = {
        error,
      };
    },
    getRMAFileSuccess(state, ficha) {
      state.rmaFile.data = ficha;
      state.rmaFile.status = {
        downloaded: true,
      };
    },

    deleteRMAFileRequest(state) {
      state.rmaFileDelete.status = {
        deleting: true,
      };
    },
    deleteRMAFileError(state, error) {
      state.rmaFileDelete.data = null;
      state.rmaFileDelete.status = {
        error,
      };
    },
    deleteRMAFileSuccess(state, ficha) {
      state.rmaFileDelete.data = ficha;
      state.rmaFileDelete.status = {
        deleted: true,
      };
    },
  },
  actions: {
    getFichaCliente({ commit }, clienteId) {
      commit("getClienteFichaRequest");
      clienteService
        .loadCliente(clienteId)
        .then((env) => {
          commit("getClienteFichaSuccess", env);
        })
        .catch((error) => {
          commit("getClienteFichaError", error);
        });
    },
    newCliente({ commit }, body) {
      commit("newClienteRequest");
      clienteService
        .newCliente(body)
        .then((cliente) => {
          commit("newClienteSuccess", cliente);
        })
        .catch((error) => {
          commit("newClienteError", error);
        });
    },
    updateCliente({ commit }, body) {
      commit("editClienteRequest");
      clienteService
        .updateCliente(body)
        .then((Res) => {
          commit("editClienteSuccess", Res);
        })
        .catch((error) => {
          commit("editClienteError", error);
        });
    },
    cambiarEstadoCliente({ commit }, idCliente) {
      commit("editClienteEstadoRequest");
      clienteService
        .cambiarEstadoCliente(idCliente)
        .then((Res) => {
          commit("editClienteEstadoSuccess", Res);
        })
        .catch((error) => {
          commit("editClienteEstadoError", error);
        });
    },
    desactivarCliente({ commit }, id) {
      commit("desactivarClienteRequest");
      clienteService
        .desactivarCliente(id)
        .then((cliente) => {
          commit("desactivarClienteSuccess", cliente);
        })
        .catch((error) => {
          commit("desactivarClienteError", error);
        });
    },
    getRMAFile({ commit }, req) {
      commit("getRMAFileRequest");
      clienteService
        .getRMAFile(req.cliente, req.procesoId)
        .then((env) => {
          commit("getRMAFileSuccess", env);
        })
        .catch((error) => {
          commit("getRMAFileError", error);
        });
    },
    deleteRMAFile({ commit }, req) {
      commit("deleteRMAFileRequest");
      clienteService
        .deleteRMAFile(req.cliente, req.procesoId)
        .then((env) => {
          commit("deleteRMAFileSuccess", env);
        })
        .catch((error) => {
          commit("deleteRMAFileError", error);
        });
    },
  },
};
